(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('ExportSelectionCtrl', ExportSelectionCtrl)
      .directive('tfcExportSelection', tfcExportSelection)
      .constant('ExportType', {
        'csv' : { name: 'csv', fileType: 'text/csv', gaKey: 'CSV' },
        'excel' : { name: 'excel', fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', gaKey: 'Excel' },
        'pdf': { name: 'pdf', fileType: 'pdf', gaKey: 'PDF' }
      });

  function ExportSelectionCtrl($state,$stateParams, StandardReports, Filters, PageConfig, AnalyticsHelper, ExportType) {
    var vm = this;

    var stateReportMap = _.reduce(_.values(PageConfig), function(acc, pageObj){
      acc[pageObj.stateName] = pageObj;
      return acc;
    }, {});

    function getCurrentPage(){
      var state = $state.current.name;
     return stateReportMap[state];
    }

    function exportFunc(fileType, gaKey) {
      return function () {
        var pageObj = getCurrentPage();
        if(pageObj) {
          StandardReports.findUserStores()
              .then( function (userStores) {
                var selectedStoreKeys = StandardReports.defaultSelectedStores(userStores, $stateParams.storeKey);
                var queryParams = _.extend(Filters.getFilterParams().queryParams, {storeKey: selectedStoreKeys});
                StandardReports.downloadReport(pageObj.exportUrl, queryParams, fileType);
                AnalyticsHelper.sendDataDownloadEvent(gaKey, pageObj.displayName);
              });
        }
      };
    }

    function pdfExport() {
      var filename = 'TrueFitReport-' + getCurrentPage().displayName.replace(/\s-\s|\s/g, "_");

      html2canvas(document.getElementById('analytics-page'), { scrollY: -window.scrollY })
          .then(function (canvas) {
        var data = canvas.toDataURL();

        var filterContents = getFiltersForExport();

        var content = [getPageTitle()]
            .concat(filterContents)
            .concat(["\n","\n"])
            .concat({
              image: data,
              width: 400
            });

        var docDefinition = {
          content: content
        };
        pdfMake.createPdf(docDefinition).download(filename);
        AnalyticsHelper.sendDataDownloadEvent(ExportType.pdf.gaKey, getCurrentPage().displayName);
      });
    };

    var exportTypes = [
      { type: ExportType.csv.name, exportFunc: exportFunc(ExportType.csv.fileType, ExportType.csv.gaKey) },
      { type: ExportType.pdf.name, exportFunc: pdfExport },
      { type: ExportType.excel.name, exportFunc: exportFunc(ExportType.excel.fileType, ExportType.excel.gaKey) }
    ];

    vm.pageExports = function () {
      var pageObj = getCurrentPage();
      return pageObj && _.map(pageObj.exportTypes, function (type) {
        return _.find(exportTypes, { type: type.name });
      });
    };

    function getPageTitle(){
      return { text:  "Dashboard: " + getCurrentPage().displayName, bold: true, size: 25 }
    }

    function getFiltersForExport() {

      var params = Filters.getFilterParams();

      var filterHeader = {text: "\n Selected Filters:", bold: true, size: 25};

      var stores = $stateParams.storeKey ? filterExportLine("Stores: ",  $stateParams.storeKey) : [];

      var detailsLevelToString = filterExportLine("Detail Level: ", [params.pathParams.detailLevel]);

      var deviceTypes = filterExportLine("Device Type: ", _.map(params.queryParams.deviceType, function (value) {
        return value.replace("_", " ");
      }));

      var continents = filterExportLine("Continents: ",  params.queryParams.continent);

      var countries = filterExportLine("Countries: ",  params.queryParams.country);

      var locales = filterExportLine("Locales: " , params.queryParams.uiLocale);

      var hierarchies = filterExportLine(
          "Hierarchies: ",
          [
            params.queryParams.department,
            params.queryParams.category,
            params.queryParams.classification
          ],
          " / "
      );

      // filter out empty strings
      return[
        filterHeader,
        detailsLevelToString,
        stores,
        deviceTypes,
        continents,
        countries,
        locales,
        hierarchies
      ];

    }

    function filterExportLine(filterHeader, filterValues, separator) {
      return {
        text: [
          {text: filterHeader, size: 25},
          filterValues.length ? _.map(filterValues, _.upperFirst).join(separator ? separator: ", "): "All"
        ]
      };
    }

  }

  function tfcExportSelection() {
    return {
      restrict: 'E',
      bindToController : true,
      controller : 'ExportSelectionCtrl as vm',
      scope: {},
      templateUrl: 'StandardReports/Util/ExportSelection/ExportSelection.tmpl.html'
    };
  }

})();
